import { Component, h, Host, Prop } from "@stencil/core";

@Component({
    tag: "ux-chat-typing-indicator",
    styleUrl: "chat-typing-indicator.scss",
    shadow: true
})
export class ChatTypingIndicator {
    /**
     * The text to show before the typing indicator dots
     */
    @Prop() readonly text?: string;

    render() {
        return (
            <Host>
                <ux-copy variant="default">
                    {this.text}
                    <span class="typing-dots">
                        <span class="dot"></span>
                        <span class="dot"></span>
                        <span class="dot"></span>
                    </span>
                </ux-copy>
            </Host>
        );
    }
}
